/* LTB — Calendrier de l'Avent : le compte à rebours.

   Les chiffres sont déjà rendus par Liquid — ce script ne fait que les tenir à
   jour, puis basculer sur l'appel à découvrir quand l'heure est passée. Si la
   date est mal saisie, il ne touche à rien : la section garde l'état écrit
   plutôt que d'afficher des tirets. */
(() => {
  const deuxChiffres = (n) => String(n).padStart(2, '0');

  // L'heure du serveur (`ltb-heure.js`), pas celle de l'appareil : un
  // téléphone en avance ne doit pas voir le bouton avant midi.
  const heure = () => (window.ltbHeure ? window.ltbHeure.maintenant() : Date.now());
  const quandPret = (fn) => (window.ltbHeure ? window.ltbHeure.pret : Promise.resolve()).then(fn);

  const brancher = (racine) => {
    if (racine.dataset.aventPret) return;

    const cible = Date.parse(racine.dataset.ltbAventCible || '');
    if (Number.isNaN(cible)) return;

    const attente = racine.querySelector('[data-avent-attente]');
    const revele = racine.querySelector('[data-avent-revele]');
    // Ouverture à tous : vide ou mal saisie, on considère la prévente ouverte
    // à tous dès l'échéance, comme avant.
    const tous = Date.parse(racine.dataset.ltbAventTous || '');
    const reserve = racine.querySelector('[data-avent-reserve]');
    const pourTous = racine.querySelector('[data-avent-tous]');
    const cases = {
      jours: racine.querySelector('[data-avent-jours]'),
      heures: racine.querySelector('[data-avent-heures]'),
      minutes: racine.querySelector('[data-avent-minutes]'),
      secondes: racine.querySelector('[data-avent-secondes]'),
    };
    if (!cases.jours) return;

    racine.dataset.aventPret = '1';

    let minuterie = null;

    // Après l'échéance : réservé aux inscrits jusqu'à l'ouverture à tous,
    // puis le bouton. La minuterie ne s'arrête qu'à ce second moment.
    const basculer = (maintenant) => {
      if (attente) attente.hidden = true;
      if (revele) revele.hidden = false;
      const ouvertATous = Number.isNaN(tous) || !reserve || maintenant >= tous;
      if (reserve) reserve.hidden = ouvertATous;
      if (pourTous) pourTous.hidden = !ouvertATous;
      if (ouvertATous && minuterie) clearInterval(minuterie);
      return ouvertATous;
    };

    const battre = () => {
      const maintenant = heure();
      const reste = Math.floor((cible - maintenant) / 1000);

      if (reste <= 0) return basculer(maintenant);

      const j = Math.floor(reste / 86400);
      cases.jours.textContent = j > 99 ? String(j) : deuxChiffres(j);
      cases.heures.textContent = deuxChiffres(Math.floor((reste % 86400) / 3600));
      cases.minutes.textContent = deuxChiffres(Math.floor((reste % 3600) / 60));
      cases.secondes.textContent = deuxChiffres(reste % 60);
      return false;
    };

    // Rien à tenir à jour si tout est déjà ouvert au chargement. D'ici là,
    // l'état rendu par Liquid reste affiché.
    quandPret(() => {
      if (!battre()) minuterie = setInterval(battre, 1000);
    });
  };

  const init = (portee) => {
    (portee || document).querySelectorAll('[data-ltb-avent]').forEach(brancher);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // L'éditeur de thème remonte la section : on rebranche ce qu'il réinjecte.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
